import React from "react";

const NotFound = (props) => {
  return (
    <div className="main-page-container">
      <span>not found</span>
    </div>
  );
};

export default NotFound;
